module.exports = __webpack_public_path__ + "img/4_de.ebb6d284.webp";